import { unitStrict } from '@lib/style/unit';
import { PAGE_HEADER_THEME } from '@packages/layout/lib/PageHeader/theme';

export const _height = (device = 'desktop') => unitStrict(PAGE_HEADER_THEME.get(`size.${device}`));
